import instance, { ADMIN_PREFIX } from 'services/api';
import {
  AppointmentsChartsResponse,
  IpChartsResponse,
  OrganizationChartsResponse,
  UsersChartsResponse
} from 'types/api/analytics';

export const fetchUsersCharts = async (): Promise<UsersChartsResponse> => {
  const res = await instance.get<UsersChartsResponse>(
    `${ADMIN_PREFIX}/charts-data/users-charts`
  );

  return res.data;
};

export const fetchOrganizationCharts =
  async (): Promise<OrganizationChartsResponse> => {
    const res = await instance.get<OrganizationChartsResponse>(
      `${ADMIN_PREFIX}/charts-data/organization-charts`
    );

    return res.data;
  };

export const fetchIpCharts = async (): Promise<IpChartsResponse> => {
  const res = await instance.get<IpChartsResponse>(
    `${ADMIN_PREFIX}/charts-data/patients/ip-data`
  );

  return res.data;
};

/**
 * Cycle-19 endpoint — backs the appointments TotalCard + the
 * AnalyticsAppointments date-series + status pie. Status keys are
 * human labels (created / approved / completed / …) matching the
 * FE APPOINTMENT_STATUSES constant.
 */
export const fetchAppointmentsCharts =
  async (): Promise<AppointmentsChartsResponse> => {
    const res = await instance.get<AppointmentsChartsResponse>(
      `${ADMIN_PREFIX}/charts-data/appointments-charts`
    );

    return res.data;
  };

/**
 * GET /google-analytics — primary review aggregate (totals + revenue+quantity
 * breakdown) used by store/analytics/slice + the Partner Analytics page.
 * `query` is the already-serialised search-params string the caller built.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const fetchAnalyticsReview = async (query: string): Promise<any> => {
  const res = await instance.get(`${ADMIN_PREFIX}/google-analytics?${query}`);

  return res.data?.data;
};

/**
 * GET /google-analytics/monthly — month-by-month dynamics series.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const fetchAnalyticsMonthly = async (query: string): Promise<any> => {
  const res = await instance.get(
    `${ADMIN_PREFIX}/google-analytics/monthly?${query}`
  );

  return res.data?.data;
};

/**
 * GET /google-analytics/utm-values — UTM facet aggregations for the same date
 * window the review/monthly queries use.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const fetchAnalyticsUtmValues = async (query: string): Promise<any> => {
  const res = await instance.get(
    `${ADMIN_PREFIX}/google-analytics/utm-values?${query}`
  );

  return res.data?.data;
};
